import {
  AudioPresets,
  ExternalE2EEKeyProvider,
  RoomConnectOptions,
  RoomOptions,
  ScreenSharePresets,
  VideoPresets,
} from 'livekit-client';
import {
  VoiceChannelParticipantLocal,
  VoiceChannelParticipantRemote,
} from 'src/provider/VoiceChannel/livekit/types';

export const state = {
  isFrontFacing: false,
  encoder: new TextEncoder(),
  decoder: new TextDecoder(),
  defaultDevices: new Map<MediaDeviceKind, string>(),
  bitrateInterval: undefined as any,
  e2eeKeyProvider: new ExternalE2EEKeyProvider(),
};

export const roomOpts: RoomOptions = {
  adaptiveStream: true,
  dynacast: true,
  audioOutput: {
    deviceId: 'default',
  },
  publishDefaults: {
    simulcast: false,
    // videoSimulcastLayers: [VideoPresets.h90, VideoPresets.h216],
    videoCodec: 'h264',
    dtx: true,
    red: true,
    forceStereo: false,
    screenShareEncoding: ScreenSharePresets.h720fps15.encoding,
    videoEncoding: VideoPresets.h720.encoding,
    audioPreset: AudioPresets.speech,
    scalabilityMode: 'L3T3',
  },
  videoCaptureDefaults: {
    resolution: VideoPresets.h720.resolution,
  },
  e2ee: undefined,
};

export const connectOpts: RoomConnectOptions = {
  autoSubscribe: true,
};

export const initialInput = 'default';

export const initialParticipant: Partial<
  VoiceChannelParticipantLocal | VoiceChannelParticipantRemote
> = {
  muted: false,
  deaf: false,
  sharing: false,
  camera: false,
  raisedHand: false,
  role: null,
};

export const initialPreConnectionOptions = { micOn: true, cameraOn: false };
